export enum SubscriptionStatusDTO {
    Active = "Active",
    Canceled = "Canceled",
    Expired = "Expired",
    WaitingPayment = "WaitingPayment"
}
